<template lang="pug">
  .flow-builder-view-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(
        v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)",
        :key="platform.platform_id",
        :style="{'background-color': platformColor(platform.name, 0.7)}"
      ) {{ platform.title }}
      b-badge(
        v-if="selectedPlatformsObjects.slice(sliceEnd).length",
        variant="soft-secondary"
      ) {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(
          placeholder="- Agregar plataformas -",
          :options="parsedPlatforms",
          :disabled="disabled",
          :value="selected_platforms",
          @input="updatePlatforms",
          multiple,
          :limit="3",
          :searchable="false"
        )
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Actualizar información del usuario
        p.text-secondary.text-sm Te permite guardar un nuevo valor en las variables del usuario.
        save-user-properties(
          v-for="(element, elementIndex) in visibleElements",
          v-if="element.type === 'user_property'",
          :key="elementIndex",
          :id="`element_${element.element_id}`",
          :disabled="disabled",
          :block_id="block_id",
          v-bind="element",
          @destroy="destroyTemplateElement(element)"
        )
        add-element-button(v-if="!disabled", @click="createTemplateElement")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import templateCommon from '@/helpers/template-common'
import SaveUserProperties from '@/components/templates/SaveUserProperties.vue'
import AddElementButton from '@/components/AddElementButton.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'

const propertyController = createNamespacedHelpers('property')

export default {
  mixins: [templateCommon],
  data () {
    return {
      visibleLimit: 10
    }
  },
  methods: {
    ...mapActions(['property/all']),
    getUserProperties () {
      const self = this

      this['property/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return this.$message.error('res.error')
        }
      })
    }
  },
  computed: {
    ...propertyController.mapState({
      properties: state => state.properties
    }),
    visibleElements () {
      return this.Elements.slice(this.visibleLimit * -1)
    }
  },
  mounted () {
    this.getUserProperties()
  },
  created () {
    this.createTemplateElement = () => {
      const self = this
      const element = {
        type: 'user_property',
        number: self.Elements.length + 1,
        attributes: [
          { name: 'property_id', value: null },
          { name: 'property_value', value: '' }
        ]
      }

      this.createElement(this.block_id, this.template_id, element)
    }

    this.destroyTemplateElement = (element) => {
      this.destroyElement(this.block_id, this.template_id, element)
    }
  },
  components: {
    SaveUserProperties,
    AddElementButton,
    TemplateTools
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-view-template {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
